import { utils } from '@weapp/ui';
import { classnames } from '@weapp/utils';
import React, { PureComponent } from 'react';
import { When } from 'react-if';
import event from '../../components/event';
import { LayoutType, pageViewClsPrefix } from '../../constants';
import { initFlowPageStyle } from '../../utils/page-style';
import { WithAsyncModuleCom } from '../WithAsyncModuleCom';
import BackgroundMask from './BackgroundMask';
import './Styled.less';
import { FlowStyledProps, MStyledProps, StyledStates } from './types';
import { getIsEmptyPageBgConfig } from './utils';

const clsName = `${pageViewClsPrefix}-styled-flow`;

class Styled extends PureComponent<FlowStyledProps, StyledStates> {
  ref = React.createRef<HTMLDivElement>();

  constructor(props: MStyledProps) {
    super(props);

    initFlowPageStyle(props.data, props.pageId as string, clsName, props.clientType);
  }

  componentDidMount() {
    this.props.mounted?.(this.ref.current!, event);
  }

  getSnapshotBeforeUpdate(prevProps: MStyledProps) {
    const { data, pageId, clientType } = this.props;

    if (!utils.isEqual(data, prevProps.data)) {
      initFlowPageStyle(data, pageId as string, clsName, clientType);
    }
  }

  render() {
    const {
      pageBgConfig, className = '', clientType, children,
    } = this.props;
    const clsNameStr = `${className} ${clsName}`.trim();
    const isEmptyPageBgConfig = getIsEmptyPageBgConfig(pageBgConfig);

    return (
      <div
        ref={this.ref}
        className={classnames(`${clsNameStr}`, {
          [`${pageViewClsPrefix}-styled-flow-background`]: !utils.isEmpty(pageBgConfig),
        })}
      >
        <When weId={`${this.props.weId || ''}_6a08sw`} condition={!isEmptyPageBgConfig}>
          <BackgroundMask
            weId={`${this.props.weId || ''}_l5m7gb`}
            pageBgConfig={pageBgConfig}
            clientType={clientType}
            layoutType={LayoutType.FlowLayout}
          />
        </When>
        {children}
      </div>
    );
  }
}

export default WithAsyncModuleCom(Styled as any, ['@weapp/ebdcoms']);
